export enum FilterCategories {
  Location = 'location',
  MRN = 'mrn',
  PatientName = 'patient_name',
  Status = 'status',
  Type = 'type',
}

export const FilterLabels = {
  [FilterCategories.Location]: 'Location',
  [FilterCategories.MRN]: 'MRN',
  [FilterCategories.PatientName]: 'Patient Name',
  [FilterCategories.Status]: 'Status',
  [FilterCategories.Type]: 'Type',
}
